/**
 * 사용자PC 접수(오더)목록 페이지 ($j.Pages.Desktop.Orders / body data-page-name="Orders")
 *
 * 현재 범위 (점진 이관 1단계)
 * ───────────────────────────
 * /u/orders 는 아직 레거시 public/js/u-order-list.js(엑셀형 테이블) +
 * u-order-edit.js(거래명세서 편집기) 두 파일이 전역함수로 구동한다. 이 모듈은 그 중
 * "명확히 분리되는" 기능부터 $j.Pages.Desktop.Orders 로 흡수하는 진입점이다.
 *
 * 1단계로 오더 데이터 스토어(OrderStore)를 이 모듈이 소유한다.
 *
 * 초기화 순서 (중요)
 * ──────────────────
 * 레거시 함수들이 전역 orderTax 를 "동기적으로" 참조한다(특히 초기 목록 로드 search()).
 * app.js 오토로더는 document.ready 에서 이 모듈을 비동기 import 하므로, 블레이드가
 * document.ready 에서 곧바로 search() 를 부르면 orderTax 가 아직 없다.
 * → 블레이드의 자동 부트스트랩을 window.__ordersPageBoot 함수로 바꿔두고,
 *   initialize() 가 (1) window.orderTax 노출 → (2) __ordersPageBoot() 호출 순서로 구동한다.
 */
import OrderStore from './Orders/OrderStore';
import PhotoUploader from './Orders/PhotoUploader';
import ContractAutocomplete from './Orders/ContractAutocomplete';
import BizForm from './Orders/BizForm';
import ExpensePanel from './Orders/ExpensePanel';
import DragMove from './Orders/DragMove';
import SearchFilter from './Orders/SearchFilter';
import FilterDropdown from './Orders/FilterDropdown';
import ListRender from './Orders/ListRender';
import DateToolbar from './Orders/DateToolbar';
import CheckboxHelpers from './Orders/CheckboxHelpers';
import MemoMessage from './Orders/MemoMessage';
import PaymentSettle from './Orders/PaymentSettle';
import BillStatus from './Orders/BillStatus';
import BillSave from './Orders/BillSave';
import PopupOpener from './Orders/PopupOpener';
import MultiIssue from './Orders/MultiIssue';
import Misc from './Orders/Misc';

export default class Orders {
    constructor() {
        // 작업사진 업로드/뷰어 (레거시 photoUpload/uploadStart/photozoom 이관).
        this.photo = new PhotoUploader();
        // bizform 거래처명 자동완성 (레거시 checkInfoChangeCont/showAllCList/... 이관).
        this.contract = new ContractAutocomplete();
        // 거래명세서/세금계산서 편집기 (레거시 u-order-edit.js 전체 이관).
        this.bizform = new BizForm();
        // 오더 상세팝업 경비(지출/수당/선출금) 패널 (레거시 showDetailList_inside/... 이관).
        this.expense = new ExpensePanel();
        // 상세팝업 드래그 이동 (레거시 addListeners/mouseUp/mouseDown/divMove 이관).
        this.drag = new DragMove();
        // 검색+필터적용 코어 (레거시 search/search_from_server/apply_filter/... 이관).
        this.searchFilter = new SearchFilter();
        // 컬럼 필터 드롭다운 UI (레거시 filter_set/show_filterList/doSerch_Start/... 이관).
        this.filterDropdown = new FilterDropdown();
        // 목록 렌더링 (레거시 render_order_all/get_order_line_html/show_payStatus/... 이관).
        this.listRender = new ListRender();
        // 검색툴바 기간프리셋+달력팝업 (레거시 setTimeTo/calanderWinPop/... 이관).
        this.dateToolbar = new DateToolbar();
        // 체크박스 공용 헬퍼 (세금/다중발행 코어 슬라이스 A).
        this.checkbox = new CheckboxHelpers();
        // 결제메모 등록/삭제/조회 (세금/다중발행 코어 슬라이스 G).
        this.memo = new MemoMessage();
        // 수금/결제 상태 처리 (세금/다중발행 코어 슬라이스 F).
        this.payment = new PaymentSettle();
        // 세금계산서/발행 상태 처리 (세금/다중발행 코어 슬라이스 C).
        this.billStatus = new BillStatus();
        // 계산서/결제 정보 저장·초기화 (세금/다중발행 코어 슬라이스 D).
        this.billSave = new BillSave();
        // 오더 상세팝업 진입점(중앙 허브) (세금/다중발행 코어 슬라이스 E).
        this.popupOpener = new PopupOpener();
        // 세금계산서 다중발행 모달 (세금/다중발행 코어 슬라이스 B — 최종).
        this.multiIssue = new MultiIssue();
        // 오더목록 페이지 잡다 유틸 (구 u-order-list.js 잔류분 — 파일 폐기).
        this.misc = new Misc();
    }

    initialize() {
        // (1) 레거시(u-order-list.js / u-order-edit.js)가 참조하는 전역 스토어 인스턴스를 노출.
        //     레거시 전역명 `orderTax`(인스턴스)를 그대로 유지한다.
        window.orderTax = OrderStore.get_instance();

        // (1-1) 구 u-order-list.js 최상단 var 로 초기화되던 공유 전역을 여기서 초기화한다(파일 폐기 대체).
        //       모든 모듈이 window.* 로 읽고 쓴다(reLoadOrderNums/reLoadOrderNumsNo/lastPageCheckSt/multiMoreList).
        window.reLoadOrderNums = [];
        window.reLoadOrderNumsNo = 0;
        window.lastPageCheckSt = {};
        window.multiMoreList = [];

        // (2) 작업사진 진입점을 레거시 호출처(bizform_otherform.inc.php · orders.blade onchange)에 브리지.
        window.photoUpload = this.photo.trigger;
        window.uploadStart = this.photo.uploadStart;
        window.photozoom   = this.photo.zoom;

        // (3) 거래처 자동완성 진입점을 레거시 호출처(bizform.php onkeyup/onclick · 드롭다운 · edit.js)에 브리지.
        window.checkInfoChangeCont = this.contract.onInputChange;
        window.showAllCList        = this.contract.showAll;
        window.GetcontractListSelA = this.contract.save;
        window.serCompleteNameuse  = this.contract.use;
        window.deleteMyConameone   = this.contract.deleteName;
        window.get_mem_ContactLists = this.contract.loadList;

        // (4) 거래명세서/세금계산서 편집기(구 u-order-edit.js)의 전역 표면을 그대로 브리지.
        //     호출처: bizform.php · bizform_otherform.inc.php · orders.blade · u-order-list.js · 자체 생성 onclick.
        const b = this.bizform;
        window.get_myCo_DocList = b.get_myCo_DocList;
        window.getMyCoInfo      = b.getMyCoInfo;
        window.checkBizTitle    = b.checkBizTitle;
        window.make_DocList     = b.make_DocList;
        window.getOthereCoinfo  = b.getOthereCoinfo;
        window.get_Other_DocList = b.get_Other_DocList;
        window.add_Subject      = b.add_Subject;
        window.checkdefSetBizForm = b.checkdefSetBizForm;
        window.coinfosetClear   = b.coinfosetClear;
        window.getMyDocInfoSet  = b.getMyDocInfoSet;
        window.make_BixForm     = b.make_BixForm;
        window.SaveCoDoc        = b.SaveCoDoc;
        window.fontSetDig       = b.fontSetDig;
        window.fsSelect         = b.fsSelect;
        window.selFontname      = b.selFontname;
        window.selFontsize      = b.selFontsize;
        window.saveFontSet      = b.saveFontSet;
        window.exportContract   = b.exportContract;

        // (5) 경비 패널 진입점 브리지 (show_Pop_BizForm 이 loadPanel 호출 · 폼/목록 onclick).
        const e = this.expense;
        window.showDetailList_inside = e.loadPanel;
        window.save_accountForm      = e.save;
        window.add_expancsemore      = e.toggleForm;
        window.expase_radioTypesel   = e.selectType;
        window.del_editJob           = e.editOrDelete;

        // (6) 드래그 이동 진입점 브리지 (show_Pop_BizForm 이 addListeners 호출).
        window.addListeners = this.drag.attach;

        // (7) 검색+필터적용 코어 브리지 (블레이드 onclick/onkeyup · __ordersPageBoot · list.js 잔류 필터UI가 호출).
        //     ⚠ __ordersPageBoot 이 search()/set_checked_search_opt_list() 를 부르므로 그보다 먼저 노출돼야 한다.
        const s = this.searchFilter;
        window.search                    = s.search;
        window.search_from_server        = s.searchFromServer;
        window.apply_filter              = s.applyFilter;
        window.keyword_delay_search      = s.keywordDelaySearch;
        window.get_checked_search_opt_list = s.getCheckedSearchOptList;
        window.set_checked_search_opt_list = s.setCheckedSearchOptList;

        // (8) 컬럼 필터 드롭다운 UI 브리지 (블레이드 컬럼헤더/필터입력 onclick·onkeyup 등).
        const fd = this.filterDropdown;
        window.filter_set       = fd.filterSet;
        window.hide_filterList  = fd.hideList;
        window.doSerch_Start    = fd.doSearchStart;
        window.filter_reset     = fd.filterReset;
        window.reset_filter_all = fd.resetFilterAll;
        window.resetSearchn     = fd.resetSearch;
        window.checkKeyUPFilter = fd.checkKeyUpFilter;
        window.show_filter_pop  = fd.showFilterPop;

        // (9) 목록 렌더링 브리지 (SearchFilter/ExpensePanel/list.js 잔류·생성 onclick 이 호출).
        const lr = this.listRender;
        window.render_order_all     = lr.render_order_all;
        window.get_orders           = lr.get_orders;
        window.get_order_payed_type = lr.get_order_payed_type;
        window.showOrderInfo        = lr.showOrderInfo;
        window.hideSooHPinfo        = lr.hideSooHPinfo;

        // (10) 검색툴바 기간프리셋+달력팝업 브리지 (블레이드 툴바 onclick · __ordersPageBoot · /u/main opener 콜백).
        const dt = this.dateToolbar;
        window.calanderWinPop     = dt.calanderWinPop;
        window.popUp_InitNoticeGet = dt.popUp_InitNoticeGet;
        window.popExistsCheck     = dt.popExistsCheck;
        window.getDateValue       = dt.getDateValue;
        window.getStatusofPopup   = dt.getStatusofPopup;
        window.setTimeToAll       = dt.setTimeToAll;
        window.setTimeTo          = dt.setTimeTo;
        window.lastSetDodate      = dt.lastSetDodate;

        // (11) 체크박스 공용 헬퍼 브리지 (블레이드 onclick · 잔류 list.js · SearchFilter 가 호출).
        const cb = this.checkbox;
        window.check_all_not         = cb.check_all_not;
        window.unSelDoPreList        = cb.unSelDoPreList;
        window.make_checkBoxStatus   = cb.make_checkBoxStatus;
        window.tr_checkbox_onoff     = cb.tr_checkbox_onoff;
        window.checkdoneornot        = cb.checkdoneornot;
        window.get_checked_order_list = cb.get_checked_order_list;
        window.toggle_checkbox_all   = cb.toggle_checkbox_all;

        // (12) 결제메모 브리지 (팝업 메모탭 onclick · 생성 onclick).
        const mm = this.memo;
        window.order_paymemoSave  = mm.order_paymemoSave;
        window.changed_messageShow = mm.changed_messageShow;
        window.readMgonly         = mm.readMgonly;
        window.messagedeleteone   = mm.messagedeleteone;

        // (13) 수금/결제 브리지 (블레이드 결제방식 라디오 · bizform.php 수금상태 onclick/onkeyup · 잔류 list.js 생성 onclick).
        const pm = this.payment;
        window.payTypeSetToNew          = pm.payTypeSetToNew;
        window.payat_misoocheck         = pm.payat_misoocheck;
        window.get_lastMisoo            = pm.get_lastMisoo;
        window.get_number_only          = pm.get_number_only;
        window.base_priceput_new        = pm.base_priceput_new;
        window.pstCh                    = pm.pstCh;
        window.payOkset                 = pm.payOkset;
        window.multiPle_priceTotalGetShow = pm.multiPle_priceTotalGetShow;

        // (14) 세금계산서/발행 상태 브리지 (bizform.php 발행상태 onclick · 잔류 list.js).
        //      getBillCheckN 은 check_BillStatus 전용 모듈-내부 함수라 브리지하지 않는다.
        const bs = this.billStatus;
        window.billNotStatusSet     = bs.billNotStatusSet;
        window.BillTypeSetTo        = bs.BillTypeSetTo;
        window.check_BillStatus_new = bs.check_BillStatus_new;
        window.check_BillStatus     = bs.check_BillStatus;

        // (15) 계산서/결제 저장·초기화 브리지 (bizform.php 저장/초기화 onclick · reset_billset_new 내부 resetBillOne).
        const bv = this.billSave;
        window.save_bill_info_new = bv.save_bill_info_new;
        window.reset_billset_new  = bv.reset_billset_new;
        window.resetBillOne       = bv.resetBillOne;

        // (16) 오더 상세팝업 진입점 브리지 (ListRender 생성 onclick allSetIn_new · 잔류 list.js show_Pop_BizForm ·
        //      MemoMessage 가 renderPayMemoHtml 을 bare 로 호출하므로 반드시 노출).
        //      readMgonly_new 는 show_Pop_BizForm 전용 모듈-내부 함수라 브리지하지 않는다.
        const po = this.popupOpener;
        window.allSetIn_new      = po.allSetIn_new;
        window.show_Pop_BizForm  = po.show_Pop_BizForm;
        window.renderPayMemoHtml = po.renderPayMemoHtml;

        // (17) 다중발행 모달 브리지 (bizform.php·bizform_otherform.inc.php onclick · 생성 onclick 문자열 ·
        //      이미 이관된 모듈: BillStatus(multiDocumentListGet/multi_sel_list_do) · BillSave(popmultisel_*) ·
        //      PaymentSettle(IntvalGet, bare 8회)). 모듈-내부(renderMulti*/_multiStx1/make_Array_multiPleMore)는 제외.
        const mi = this.multiIssue;
        window.IntvalGet                       = mi.IntvalGet;
        window.popmultisel_checkCheck_new      = mi.popmultisel_checkCheck_new;
        window.popmultisel_checkCheck_paystatus_new = mi.popmultisel_checkCheck_paystatus_new;
        window.popmultisel_checkCheck          = mi.popmultisel_checkCheck;
        window.reset_multiAll_billset_new      = mi.reset_multiAll_billset_new;
        window.multiDocumentListGet            = mi.multiDocumentListGet;
        window.multiSelMore                    = mi.multiSelMore;
        window.multi_selorderboxset            = mi.multi_selorderboxset;
        window.multi_sel_list_do               = mi.multi_sel_list_do;
        window.checkMultiChallnot              = mi.checkMultiChallnot;
        window.add_multipleOrder               = mi.add_multipleOrder;
        window.multiTaxclose                   = mi.multiTaxclose;
        window.getMultiMoreList                = mi.getMultiMoreList;

        // (18) 오더목록 페이지 잡다 유틸 브리지 (블레이드/bizform.php onclick · __ordersPageBoot(initPP) ·
        //      이미 이관된 모듈이 detailExpanseClose 를 bare 로 호출).
        const ms = this.misc;
        window.zipserchWinJob     = ms.zipserchWinJob;
        window.fnExcelReport      = ms.fnExcelReport;
        window.bgcolorCh          = ms.bgcolorCh;
        window.Tdmouseover        = ms.Tdmouseover;
        window.Tdmouseout         = ms.Tdmouseout;
        window.detailExpanseClose = ms.detailExpanseClose;
        window.initPP             = ms.initPP;
        window.checkDefDate       = ms.checkDefDate;
        window.showClickedOrder   = ms.showClickedOrder;
        window.order_clearSet     = ms.order_clearSet;

        // (19) 블레이드 페이지 부트스트랩(달력·초기검색) 구동. orderTax 준비 이후 호출된다.
        if (typeof window.__ordersPageBoot === 'function') {
            window.__ordersPageBoot();
        }
    }
}
